import { clientData } from '../services/clientData.service'

export const ClientDataContentType = {
  PDF: 'application/pdf',
  OPTIONS: 'OPTIONS',
  JSON: 'application/json',
} as const

export type ClientDataReqItem = { id: string; createDateTime: string }

export const buildClientDataRequest = (docs: clientData, exclude?: string[]): ClientDataReqItem[] =>
  (docs || [])
    .filter((doc) => !exclude || !exclude.includes(doc.contentType))
    .map((doc) => ({ id: doc.id, createDateTime: doc.createDateTime }))

export const buildClientDataRequestForType = (docs: clientData, contentType: string): ClientDataReqItem[] =>
  (docs || [])
    .filter((doc) => doc.contentType === contentType)
    .map((doc) => ({ id: doc.id, createDateTime: doc.createDateTime }))
